import modelTemplate from '../modal/equipment-update.modal.html';
import modalController from '../modal/equipment-update.modal';
let sum = 0;
export default class EquipmentUpdateService {
  constructor($uibModal, EquipmentService, $ngRedux, $q, $interval) {
    'ngInject';
    this.$uibModal = $uibModal;
    this.EquipmentService = EquipmentService;
    this.$ngRedux = $ngRedux;
    this.$q = $q;
    this.$interval = $interval;
  }

  openEditModal(asset) {
    return this.$uibModal.open({
      animation: true,
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      template: modelTemplate,
      controller: modalController,
      controllerAs: 'modalVm',
      resolve: {
        asset: () => asset,
      },
    }).result;
  }

  /**
   *
   * @param {*} changeSet [] of {op ,id,values}
   */
  updateAssetsAttrs(changeSet) {
    return this.EquipmentService.batchPatchAttrs(changeSet);
  }

  /**
   *
   * @param {*} assets
   * @returns assets with attrs as {[normalizeKey]:{...,originalVal,value}}
   */
  getEditAssetsAttrsModel(assets = []) {
    return assets.map((a) => {
      const normalizedAttrsObject = Object.keys(a.attrs || {}).reduce(
        (acc, attrKey) => ({
          ...acc,
          [attrKey.toLowerCase()]: {
            key: attrKey,
            normalizeKey: attrKey.toLowerCase(),
            value: a.attrs[attrKey],
            originalVal: a.attrs[attrKey],
          },
        }),
        {},
      );
      return {
        ...a,
        originalAttrs: JSON.stringify(normalizedAttrsObject),
        attrs: normalizedAttrsObject,
      };
    });
  }

  /**
   * filter and index attrs by lowercase key
   * @param {*} storeData
   * @returns { allAttr, attrsWithoutReadonly, keyedAttrs }
   */
  indexAttributes(storeData) {
    const { secured, items } = storeData || {};
    const readonlyList = (secured || {}).readonly || [];

    const mappedData = items.reduce(
      (acc, item) => {
        let { allAttr = [], attrsWithoutReadonly = [], keyedAttrs = {} } = acc || {};

        const normalizeKey = item.key.toLowerCase();
        const readonly = readonlyList.includes(normalizeKey);

        const attr = { ...item, normalizeKey, readonly };

        allAttr = [...allAttr, attr];
        if (!readonly) {
          attrsWithoutReadonly = [...attrsWithoutReadonly, attr];
        }

        keyedAttrs = { ...keyedAttrs, [normalizeKey]: attr };

        return { allAttr, attrsWithoutReadonly, keyedAttrs, readonlyList };
      },

      {},
    );

    return mappedData;
  }

  /**
   *
   * @returns attributes from redux store
   */
  getAttributesFromStore() {
    return this.$q((resolve, reject) => {
      let count = 0;

      let loader = this.$interval(() => {
        const state = this.$ngRedux.getState();
        const { attributes } = state;
        let { secured = {}, isSecuredLoaded, items, loading, error } = attributes;

        if (!loading && isSecuredLoaded) {
          this.$interval.cancel(loader);
          if (error) {
            reject(error);
          } else {
            resolve({ secured, items });
          }
        }

        ++count;
        //time out if call take too long, total wait so far 4min
        if (count * 50 > 240000) {
          this.$interval.cancel(loader);
          reject('Timed out: could not read store data');
        }
      }, 50);
    });
  }

  getAttributes() {
    return this.getAttributesFromStore().then((result) => {
      return this.indexAttributes(result);
    });
  }
}
